"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListboxOptionMedia = void 0;
var _ListboxOptionMedia = require("./ListboxOptionMedia");
// TODO: in v9, move styled() from ListboxOptionMedia.jsx to here
var StyledListboxOptionMedia = _ListboxOptionMedia.ListboxOptionMedia;
exports.StyledListboxOptionMedia = StyledListboxOptionMedia;